<script>
	import tooltip from '../helpers/tooltip';

	import Info from './icons/Info.svelte';

	export let size = '20px';
	export let toolTip = null;
	export let position = 'right';
</script>

{#if toolTip}
	<i use:tooltip={{ position: position }} title={toolTip}><Info {size} /></i>
{/if}
